import React from "react";
import { Checkbox, TableCell } from "@material-ui/core";

export default function TableChecks({ items }) {
  return (
    <React.Fragment>
      {items.map((item, index) => (
        <TableCell key={index}>
          <Checkbox
            checked={item}
            disabled
            style={{
              color: item ? "#ffb600" : undefined,
            }}
          />
        </TableCell>
      ))}
    </React.Fragment>
  );
}
